import React, { useEffect } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { prettyFloatMoney } from '@/helpers/utils';
import s from './index.module.scss';

// TODO *** Revise this component due to backend change this is no longer valid component
export const IncreasedIncomeWarning = ({ amount, currentDate, className }) => {
  const mounted = React.useRef(true);
  const [incomeAmount, setIncomeAmount] = React.useState(0);
  const { t } = useTranslation('loans');

  useEffect(() => {
    if (currentDate) {
      // getIncreasedIncomeInfo().then(res => {
      //   if (res?.success && mounted.current) {
      //     const isActive = moment(currentDate).isSameOrAfter(
      //       res.data.start_date_for_income,
      //     );
      //     isActive && setIncomeAmount(res.data.increased_income);
      //   }
      // });
    }
    setIncomeAmount(amount || 0);
    return () => {
      mounted.current = false;
    };
  }, [currentDate]);

  if (currentDate && !incomeAmount) return null;

  return (
    <div className={classnames(s.wrapper, className)}>
      {incomeAmount ? (
        <>
          <div className="f-16-24 f-500">
            {t('loan_info.want_more', {
              amount: prettyFloatMoney(incomeAmount),
            })}
          </div>
          <div className="f-16-24 f-400">
            {t('loan_info.get_increased_income')}
          </div>
          <div className="f-16-24 f-400">
            {t('loan_info.increased_income_condition')}
          </div>
        </>
      ) : (
        <>
          <div className="f-16-24 f-500">
            {t('loan_info.get_increased_income')}
          </div>
          <div className="f-16-24 f-400">
            {t('loan_info.increased_income_condition')}
          </div>
        </>
      )}
    </div>
  );
};
